//frontend/src/pages/history/historystages/AncientCivilisations.jsx
import React from 'react';
import JourneyPage from '../../../components/SubjectsPage';
import historyImage from '../../../assets/history/Classical_Antiquity_-_Ancient_Rome.png';

const subTopics = [
  { name: 'Ancient Greece', route: '/History-Ancient-Greece', key: 'Ancient Greece' },
  { name: 'Ancient Rome', route: '/History-Ancient-Rome', key: 'Ancient Rome' },
  { name: 'Persian Empire', route: '/History-Persian-Empire', key: 'Persian Empire' },
  { name: 'Hellenistic World', route: '/History-Hellenistic-World', key: 'Hellenistic World' },
  { name: 'Maurya and Gupta Empires (India)', route: '/History-Maurya-Gupta', key: 'Maurya and Gupta Empires (India)'},
  { name: 'Han Dynasty (China)', route: '/History-Han-Dynasty', key: 'Han Dynasty (China)'}
];

function HistoryPageCA() {
  return (
    <JourneyPage
      title="Classical Antiquity"
      backgroundImage={historyImage}
      subTopics={subTopics}
      backRoute="/history2"
      chapterFooter=""
    />
  );
}

export default HistoryPageCA;
